
import { AxiosRequestConfig } from 'axios';

import base from '@/services/base';

import { API4 } from '@/config/apiHost';

// 微信配置
export function wechatConfig(): Promise<any> {

    const config: AxiosRequestConfig = {
        url: `${ API4 }/wxjs_config`,
        method: 'get',
        params: {
            page: location.href
        }
    };
    return base(config);
}
